import Animation from './Animation';
import './Momentum.css';

export default class Momentum extends Animation {

	constructor (master) {

		super(master, 840);
		//this.loadAudio("draw");
	}

	run () {

		var el = document.querySelector("#game-entity-player .game-entity-main");
		var elImg = document.querySelector("#game-entity-player .game-entity-main .game-entity-main-img");
		if (el && elImg) {
			el.classList.add("momentum-anim");

			const originalSrcAttr = elImg.getAttribute("src");

			setTimeout(() => {
				elImg.src = "https://moa-pull.b-cdn.net/assets/chibi/Spinelle/1/5bb2316c-3f51-4f84-88b1-b74c7b6bf25f.png";
			}, this.time * 0.6);

			setTimeout(() => {
				elImg.src = originalSrcAttr;
			}, this.time * 1.9);

			setTimeout(() => {
		    	el.classList.remove("momentum-anim");
			}, this.time * 2.5);
		}
	}
}